export const environment = {
  production: true,
  buildId: '4185621869424981',
  configFile: 'config.json',
};
